import { Outlet, Link } from "react-router-dom"
import Wrapper from "../../assets/wrappers/SharedLayout"
import { Navbar, SmallSidebar, BigSidebar } from '../../components'
import { useAppContext } from "../../context/appContext"

const SharedLayout = () => {
    const { changeShowLogout } = useAppContext()
    return (
        <Wrapper>
            <main className="dashboard">
                <SmallSidebar />
                <BigSidebar />
                <div>
                    <Navbar/>
                    <div className="dashboard-page" onClick={() => { changeShowLogout(false) }}>
                        <Outlet />
                    </div>
                </div>
            </main>

        </Wrapper>
    )
}

export default SharedLayout